module.exports = __webpack_public_path__ + "img/LOGO_white@3x.b51e7e76.png";